import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import ChatInputOnLive from '../chat-new/ChatInputOnLive'
import styled from 'styled-components'
import LiveStreamMessages from './LiveStreamMessages'
import WebsiteFontColor from '../Layouts/WebsiteFontColor'
import socket from '../../utils/socket'
import { isIPad13 } from 'react-device-detect'
import Stopwatch from '../timer/Stopwatch'
import { getCloudFrontAssetsUrl } from '../../utils/assets'

const ModalDialogStyle = {
    maxWidth: '100%',
    width: '100%',
    maxHeight: '100%',
    height: '100%',
    margin: '0',
    zIndex:'9999'
}

const ModalContentStyle = {
    width: 'inherit',
    height: 'inherit',
    background: '#000',
    textAlign: 'initial',
    color: '#fff'
}
const CommentSection = {
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0'
}

const LiveCloseSection = {
    position: 'absolute',
    display: 'flex',
    zIndex: '999',
    top: '4px',
    width: '100%'
}

const BtnStyle = {
    backgroundColor: '#0000004d',
    padding: '5px !important',
    borderRadius: '25px',
    width: '40px',
    height: '40px',
    margin: '0'
}

const SwitchCameraBtnStyle = {
    backgroundColor: '#0000004d',
    padding: '0px 9px',
    borderRadius: '25px',
    width: '40px',
    height: '40px',
    margin: '0'
}

const HorizontalUl = styled.ul`
width: 100%;
list-style-type: none;
margin: 0;
padding: 0;
overflow: hidden;
line-height: 50px;
    li {
        float: left;
        margin: auto 6px;
    }
    .userNameTranculate{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: calc(40vw);
        display: block;
    }
    @media(max-width: 768px){
        .userNameTranculate{max-width: calc(30vw);}
    }
    @media(max-width: 480px){
        .userNameTranculate{max-width: calc(25vw);}
    }
    @media(max-width: 425px){
        .userNameTranculate{max-width: calc(25vw);}
    }
    @media(max-width: 400px){
        .userNameTranculate{max-width: calc(15vw);}
    }
    @media(max-width: 330px){
        .userNameTranculate{max-width: calc(13vw);}
    }
`

const Icons = styled.div`
    width: 20px;
    height: 20px;
    background-color: ${props => props.color};
    mask: url(${props => props.image});
    -webkit-mask: url(${props => props.image}) no-repeat center / contain;
`

const TimerLi = styled.li`
    @media(max-width: 376px) {
        margin: 0px !important;
        padding-bottom: 8px;
        display: flex;
    }
`

const MediaSelection = styled.div`
    width: fit-content;
`

function LiveStreamModal(props) {

    const [isMuted, setIsMuted] = useState(true)
    const showVideoType = window.innerWidth >= 1024 && props.isPublisher === false ? 'contain' : 'cover'
    const [containOrCover, setContainOrCover] = useState(showVideoType)
    const [showMirrorVideo, setShowMirrorVideo] = useState(true)
    const [isOverlayApply, setIsOverlayApply] = useState(true)
    const [overlayPercentage, setOverlayPercentage] = useState(10)
    const [totalTipAmount, setTotalTipAmount] = useState(0)
    const [selectedVideoInputId, setSelectedVideoInputId] = useState('')
    const [selectedAudioInputId, setSelectedAudioInputId] = useState('')

    useEffect(() => {
        if (props.auth.user.role !== 'model' && props.auth.user.role !== 'proxy_user' ** props.auth.user.role !== 'live_stream_manager') {
            socket.emit('GET_VIEWER')
        }
        loadSocketEvent()
    }, [])

    const loadSocketEvent = () => {
        if (props.auth.user.role === 'model') {
            socket.on('SET_TIP_AMOUNT', (amount) => {
                setTotalTipAmount(amount)
            })
        }
    }

    const isAdmin = props.auth.user.isAdmin

    let receiverId

    if (isAdmin) {
        if (props.match.params.id === undefined) {
            receiverId = props.chat.selectedUserId
        } else {
            receiverId = props.match.params.id
        }
    } else {
        receiverId = props.chat.selectedUserId
    }

    const receiverProfileDetails = (props.chat.userProfileInfo && props.chat.userProfileInfo[receiverId])
        ? props.chat.userProfileInfo[receiverId]
        : getCloudFrontAssetsUrl('faces/avatar.png')

    const startVideoOnAlert = () => {
        props.video.current.play()
    }

    const onChangeOverlay = () => {

        if (isOverlayApply === false) {
            setIsOverlayApply(true)
            return
        }

        if (overlayPercentage === 30) {
            setOverlayPercentage(10)
            setIsOverlayApply(false)
        } else {
            setOverlayPercentage(overlayPercentage + 10)
        }
    }

    const userName = isAdmin === false ? props.auth.user.name : receiverProfileDetails.name

    const handleSelectChange = (event) => {
        const { name, value } = event.target
        if (name === 'mic') {
            const videoInputId = selectedVideoInputId ? selectedVideoInputId : props.videoInputList[0].deviceId
            props.onSwitchCamera(videoInputId, value)
            setSelectedAudioInputId(value)
        } else if (name === 'cam') {
            const audioInputId = selectedAudioInputId ? selectedAudioInputId : props.audioInputList[0].deviceId
            props.onSwitchCamera(value, audioInputId)
            setSelectedVideoInputId(value)
        }
    }

    const {
        card_background_color
    } = props.auth.appSettings

    return (
        <div className='modal fade px-0 show' role='dialog' style={{ display: 'block', backgroundColor: '#00000080' }}>
            <div className='modal-dialog' role='document' style={ModalDialogStyle}>
                <div className='modal-content' style={ModalContentStyle}>
                    {props.loading === false || isAdmin === true ?
                        <>
                            <div className='row align-items-center mx-auto' style={LiveCloseSection}>
                                <div className='col-10 text-left d-inline-block'>
                                    <HorizontalUl>
                                        <li style={{ marginLeft: '0' }}>
                                            <h4 className='mb-0 d-inline-block'><span className='badge badge-danger'
                                                style={{
                                                    paddingRight: '0.4rem',
                                                    paddingTop: '0.3rem',
                                                    paddingBottom: '0.35rem',
                                                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'
                                                }}>LIVE</span>
                                            </h4>
                                        </li>
                                        {props.isPublisher === false &&
                                            <li>
                                                {isMuted === false ?
                                                    <button className='btn shadow-none py-0 text-light'
                                                        style={{
                                                            padding: '0px',
                                                            backgroundColor: '#0000004d',
                                                            borderRadius: '25px',
                                                            width: '40px',
                                                            height: '40px',
                                                            margin: '0'
                                                        }} onClick={() => setIsMuted(true)}><i className='fas fa-volume-up'></i></button>
                                                    :
                                                    <button className='btn shadow-none py-0 text-light' style={BtnStyle} onClick={() => setIsMuted(false)}><i className='fas fa-volume-mute'></i></button>
                                                }
                                            </li>
                                        }
                                        {(props.isPublisher === true && props.isMobileDevice) &&
                                            <li>
                                                {props.isPublisherMuted === false ?
                                                    <button className='btn shadow-none py-0 text-light' style={BtnStyle} onClick={() => props.onMute()}><i className='fas fa-microphone'></i></button>
                                                    :
                                                    <button className='btn shadow-none py-0 text-light'
                                                        style={{
                                                            padding: '7px',
                                                            backgroundColor: '#0000004d',
                                                            borderRadius: '25px',
                                                            width: '40px',
                                                            height: '40px',
                                                            margin: '0'
                                                        }} onClick={() => props.onUnmute()}><i className='fas fa-microphone-slash text-danger'></i></button>
                                                }
                                            </li>
                                        }
                                        <li>
                                            {containOrCover === 'contain' ?
                                                <button className='btn shadow-none py-0 text-light' style={BtnStyle} onClick={() => setContainOrCover('cover')}><i className='fas fa-expand-arrows-alt'></i></button>
                                                :
                                                <button className='btn shadow-none py-0 text-light' style={BtnStyle} onClick={() => setContainOrCover('contain')}><i className='fas fa-expand'></i></button>
                                            }
                                        </li>
                                        {props.isPublisher === true && totalTipAmount > 0 &&
                                            <li className='align-items-center badge font-weight-bold my-3 px-2 py-2 rounded-pill'
                                                style={{ fontFamily: 'Roboto', backgroundColor: 'rgb(34 174 5)' }}>$ {totalTipAmount}</li>
                                        }
                                        <li>
                                            <b className='mb-0 userNameTranculate'>
                                                <span>{userName}</span>
                                            </b>
                                        </li>
                                        {props.isPublisher === true &&
                                            <TimerLi>
                                                <h4 className='mb-0 d-inline-block'>
                                                    <span className='badge'
                                                        style={{
                                                            paddingRight: '0.4rem',
                                                            paddingTop: '0.3rem',
                                                            paddingBottom: '0.35rem',
                                                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
                                                            backgroundColor: '#0000004d'

                                                        }}>
                                                        <Stopwatch />
                                                    </span>
                                                </h4>
                                            </TimerLi>
                                        }
                                    </HorizontalUl>
                                    {props.isPublisher === true &&
                                        <>
                                            {!isIPad13 &&
                                                <div>
                                                    <button className='btn shadow-none py-0 text-light' style={BtnStyle} onClick={() => setShowMirrorVideo(!showMirrorVideo)}><i className='fas fa-retweet' style={{ margin: '-2px' }}></i></button>
                                                </div>
                                            }
                                            <div className='mt-2'>
                                                <button className='btn shadow-none py-0 text-light' style={BtnStyle} onClick={onChangeOverlay}><i className={`fas fa-adjust ${isOverlayApply ? '' : 'fa-flip-horizontal'}`} style={{ margin: '-2px' }}></i></button>
                                            </div>
                                        </>
                                    }

                                    {/* Switch video source for mobile devices */}
                                    {
                                        (props.isPublisher === true
                                            && props.numberOfVideoDevices > 1
                                            && props.isMobileDevice) &&
                                        <div className='mt-2'>
                                            <button
                                                className='btn shadow-none text-light'
                                                style={SwitchCameraBtnStyle}
                                                onClick={props.onSwitchCamera}
                                            >
                                                <Icons image={getCloudFrontAssetsUrl('images/camera-rotate.svg')} color={'white'}></Icons>
                                            </button>
                                        </div>
                                    }

                                    {/* Switch video and audio source for desktop devices */}
                                    {
                                        props.isPublisher === true &&
                                        !props.isMobileDevice &&
                                        <>
                                            {
                                                props.videoInputList.length > 1 &&
                                                <MediaSelection className='mt-3'>
                                                    <button
                                                        className='btn shadow-none text-light mr-2'
                                                        style={SwitchCameraBtnStyle}
                                                    >
                                                        <i className='fas fa-video'></i>
                                                    </button>
                                                    <select id='cam' name='cam' value={selectedVideoInputId} onChange={handleSelectChange}>
                                                        {props.videoInputList.map((option, index) => <option key={index} value={option.deviceId}>{`CAM ${index + 1} (${option.label})`}</option>)}
                                                    </select>
                                                </MediaSelection>
                                            }
                                            {
                                                <MediaSelection className='mt-3'>
                                                    {
                                                        props.isPublisherMuted === false ?
                                                            <button
                                                                className='btn shadow-none text-light mr-2'
                                                                style={SwitchCameraBtnStyle}
                                                                onClick={() => props.onMute()}
                                                            >
                                                                <i className='fas fa-microphone'></i>
                                                            </button>
                                                            : <button
                                                                className='btn shadow-none text-light mr-2'
                                                                style={SwitchCameraBtnStyle}
                                                                onClick={() => props.onUnmute()}
                                                            >
                                                                <i className='fas fa-microphone-slash text-danger'></i>
                                                            </button>
                                                    }
                                                    {
                                                        props.audioInputList.length > 1 &&
                                                        <select id='mic' name='mic' value={selectedAudioInputId} onChange={handleSelectChange}>
                                                            {props.audioInputList.map((option, index) => <option key={index} value={option.deviceId}>{`MIC ${index + 1} (${option.label})`}</option>)}
                                                        </select>
                                                    }
                                                </MediaSelection>
                                            }
                                        </>
                                    }

                                </div>
                                <div className='col-2 text-right ml-auto d-inline-block pl-0' style={{ position: 'absolute', top: '4px', right: '0' }}>
                                    <button className='btn shadow-none py-0 px-0 mx-0 text-light' style={BtnStyle} onClick={props.handleStopClick}><i className='fas fa-times'
                                        style={{ fontSize: '25px', padding: '0', lineHeight: '1.2', marginTop: '1px', marginLeft: '1px' }}></i></button>
                                </div>
                            </div>
                            <div className='row live-streaming-section' style={{ height: '100vh' }}>
                                <div className='col-12 px-0'>
                                    <video className='janus-player-video'
                                        autoPlay
                                        playsInline
                                        ref={props.video}
                                        muted={isMuted}
                                        controls={false}
                                        style={{
                                            maxHeight: '100vh',
                                            height: '100%',
                                            objectFit: containOrCover,
                                            backgroundPosition: 'center',
                                            maxWidth: '100vw',
                                            width: '100%',
                                            margin: '0 12px',
                                            borderRadius: '0',
                                            transform: `${props.isPublisher && isIPad13 === false && showMirrorVideo ? 'scale(-1, 1)' : 'scale(1)'}`,
                                            minHeight: containOrCover === 'contain' ? '92vh' : '100vh'
                                        }}
                                    />
                                    <div className={`card-img-overlay p-0 justify-content-end ${props.isPublisher && isOverlayApply ? '' : ' bg-transparent'}`} style={{ backgroundColor: props.isPublisher && isOverlayApply ? `rgba(0,0,0,${overlayPercentage}%)` : '' }}>
                                        <LiveStreamMessages isPublisher={props.isPublisher} />
                                    </div>
                                </div>
                            </div>
                            {props.auth.user.role !== 'live_stream_manager' && <div className='row comment-tip-section text-center' style={CommentSection}>
                                <div className='col-12'>
                                    <ChatInputOnLive receiverId={receiverId} receiverProfileDetails={receiverProfileDetails.name} startVideoOnAlert={startVideoOnAlert} />
                                </div>
                            </div>}
                        </>
                        :
                        <WebsiteFontColor>
                            <div className='modal fade show' role='dialog' style={{ display: 'block', backgroundColor: '#00000080' }}>
                                <div className='modal-dialog modal-dialog-centered' role='document'>
                                    <div className='modal-content'>
                                        <div className='modal-body' style={{ backgroundColor: card_background_color }}>
                                            <div className='container'>
                                                <div className='row'>
                                                    <div className='col-12 text-center'>
                                                        <div>Go Live Stream is connecting...</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </WebsiteFontColor>
                    }
                </div>

            </div>
        </div>
    )
}

LiveStreamModal.propTypes = {
    isPublisher: PropTypes.bool.isRequired,
    handleStopClick: PropTypes.func.isRequired,
    video: PropTypes.object.isRequired,
    chat: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    isPublisherMuted: PropTypes.bool,
    onMute: PropTypes.func,
    onUnmute: PropTypes.func,
    loading: PropTypes.bool,
    numberOfVideoDevices: PropTypes.number,
    onSwitchCamera: PropTypes.func,
    audioInputList: PropTypes.array,
    videoInputList: PropTypes.array,
    isMobileDevice: PropTypes.bool
}

const mapStateToProps = state => ({
    chat: state.chat,
    auth: state.auth
})

export default connect(mapStateToProps)(withRouter(LiveStreamModal))
